module.exports = __webpack_public_path__ + "img/image-implantation-map.17ea95d4.png";